import { render } from "./sidemenu.vue?vue&type=template&id=58fa9404&scoped=true"
import script from "./sidemenu.vue?vue&type=script&lang=js"
export * from "./sidemenu.vue?vue&type=script&lang=js"

import "./sidemenu.vue?vue&type=style&index=0&id=58fa9404&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58fa9404"]])

export default __exports__